<template>

  <div class="container">
    <div class="simulator-page__title">Экзамен На право управления транспортным средством
      <div @click="$emit('show-exit-modal')" class="simulator-comeback">Выйти из симулятора</div>
    </div>

    <div class="simulator-page__subtitle">Категория: A,B и M</div>
    <p class="text">Время, отведенное на экзамен: 20 мин. 40 официальных экзаменационных билетов ПДД РФ на категории A,B и M с последними изменениями.</p>

    <div class="simulator-page__table table">
      <div class="table-row">
        <div class="table-col"></div>
        <div class="table-col">
          <img src="../../../html/assets/img/mouse.svg">
        </div>
        <div class="table-col pt-1 pb-1">
          <img src="../../../html/assets/img/keyboard.svg" class="icon-keyboard">
        </div>
      </div>

      <div class="table-row">
        <div class="table-col">Выбор вопроса из перечня</div>
        <div class="table-col">Левая кнопка <span class="icon icon-mouse"></span></div>
        <div class="table-col">Клавишами <span class="icon icon-all-btn"></span> затем ПРОБЕЛ</div>
      </div>

      <div class="table-row">
        <div class="table-col">Выбор варианта ответа</div>
        <div class="table-col">Левая кнопка <span class="icon icon-mouse"></span></div>
        <div class="table-col">Клавишами <span class="icon icon-up-down"></span></div>
      </div>

      <div class="table-row">
        <div class="table-col">Ответ на вопрос</div>
        <div class="table-col">
          <div class="flex flex-align-center flex-justify-sb ">
            <span>Кнопка</span>
            <button class="simulator-button">Ответить</button>
          </div>
        </div>
        <div class="table-col">Клавиша ПРОБЕЛ</div>
      </div>

      <div class="table-row">
        <div class="table-col">Переход к перечню</div>
        <div class="table-col">
          <div class="flex flex-align-center flex-justify-sb ">
            <span>Кнопка</span>
            <button class="simulator-button">К перечню</button>
          </div>
        </div>
        <div class="table-col">Клавиша ESC</div>
      </div>

      <div class="table-row">
        <div class="table-col">Переход к следующему/предыдущему вопросу</div>
        <div class="table-col">
          <div class="flex flex-align-center flex-justify-sb pb-1">
            <span>Кнопка</span>
            <button class="simulator-button prev">К предыдущему</button>
          </div>
          <div class="flex flex-align-center flex-justify-sb pt-1">
            <span>Кнопка</span>
            <button class="simulator-button next">К следующему</button>
          </div>
        </div>
        <div class="table-col">Клавишами <span class="icon icon-left"></span><span class="icon icon-right"></span></div>
      </div>
    </div>

    <router-link to="/simulator/list" class="btn simulator-green-btn">Начать экзамен</router-link>
  </div>
</template>

<script>
  export default {
    name: 'Rules',
  };
</script>
